import { getCurrentPSTDate } from "./dateUtils";
import moment from "moment-timezone";

export const leapYear = (year: any) => {
  return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
};

export const getReportingMonth = (inputDate: any, rollbackByMonths = 0, format="YYYY-M") => {
  const refreshMonthLookup = {
    '1-0': 11,
    '1-1': 11,
    '1-30': 12,
    '3-2': 1,
    '3-30': 2,
    '4-30': 3,
    '5-30': 4,
    '6-30': 5,
    '7-30': 6,
    '8-30': 7,
    '9-30': 8,
    '10-30': 9,
    '11-30': 10,
    '12-30': 11,
  }
  //Convert to PST time
  // let d_t : inputDate.toPST();

  let d_t = getCurrentPSTDate(inputDate)

  let adjYear = 0
  let adjMonth = 0
  let currYear = d_t.getFullYear()

  if (d_t.getTime() <= new Date(currYear, 2, 2, 15, 59, 59).getTime()) // March 2nd
  {
    adjYear = -1
  }

  if (leapYear(currYear) && d_t.getMonth() == 2 && d_t.getDate() == 1 && d_t.getTime() > new Date(currYear, 2, 1, 15, 59, 59).getTime()) // March 1st leap year
  {
    adjMonth = 1
  }

  let refreshMonth = Object.entries(refreshMonthLookup).filter(([key, value]) => {
    let currDt = new Date(currYear, Number(key.split('-')[0]) - 1, Number(key.split('-')[1]), 15, 59, 59)
    return currDt < d_t
  });

  let latestRefreshMonth = refreshMonth[refreshMonth.length - 1][1]

  let dt = new Date(currYear + adjYear, latestRefreshMonth - 1 - rollbackByMonths + adjMonth);
  return moment(dt).format(format);
};

